export default {
  inhale: 5,
  exhale: 5,
  holdInhale: 0,
  holdExhale: 0,
  isTimerRunning: false,
  interval: null,
  startTime: null,
  currentTime: null,
  showClock: true,
};
